import { API } from "@swivl-mono/api-helper";
import { DateHelper } from "@swivl-mono/helpers";
import { SequenceInterface } from "@swivl-mono/types";
import { Button, ButtonColor, Dropdown, OptionsHelper } from "@swivl-mono/ui";
import React from "react";

import { Member } from "../../../../Models/Member/Member.Current";
import { AlertsModel } from "../../../../Models/Notifications/Alerts.Model";

export function SequenceAdminTools(props: { sequence: SequenceInterface }) {
  const [hourOfDay, setHourOfDay] = React.useState(DateHelper.nowHourUTC());
  return (
    <div className="bg-white p-3 rounded-md mt-5">
      <label>ADMIN ONLY</label>
      Test Sequence
      <div className="flex flex-row">
        <Dropdown options={OptionsHelper.hoursOptionsLocalized()} value={hourOfDay} onSet={(option) => setHourOfDay(option)} />
        <div className=" ml-2">
          <Button
            color={ButtonColor.ORANGE}
            onClickAsync={async () => {
              const triggering = await API.Sequences.forceCheckSequence(Member.orgId, props.sequence.id, hourOfDay);
              if (triggering) {
                AlertsModel.successToast("Sequence Triggered");
              } else {
                AlertsModel.errorToast("Sequence Not Triggered");
              }
            }}
            className="w-full"
          >
            Trigger Sequence
          </Button>
        </div>
        <div className="flex-1 ml-2" />
      </div>
    </div>
  );
}
